import _assessmentHelper from '../common/_assessment-helper';

export default function () {

    const $instructionForm = $('.js-brta-instruction-form');
    const $submitButton = $('#sl-js-next-button');
    const $answerList = $instructionForm.find('.js-answer-list');
    const $answerItems = $answerList.find('td > div');
    const $errorMessage = $instructionForm.find('.js-answer-list .js-sl-alert-danger');

    $.each($answerItems, function (index, item) {
        $(item).on('click', function () {
            if (!isInstructionShown()) {
                showInstruction();
            } else {
                if (_assessmentHelper.isCorrectAnswer() && isErrorMessageShown()) {
                    hideErrorMessage();
                } else if (!_assessmentHelper.isCorrectAnswer() && !isErrorMessageShown()) {
                    showErrorMessage();
                }
            }
        });
    });

    $submitButton.on('click', function (event) {
        if (!_assessmentHelper.isCorrectAnswer()) {
            event.preventDefault();
            if (!isInstructionShown()) {
                showInstruction();
            } else if (!isErrorMessageShown()) {
                showErrorMessage();
            }
        }
    });

    /**
     * @returns {boolean}
     */
    function isInstructionShown() {
        return $('.js-sctn-instruction').css('display') === 'block';
    }

    function showInstruction() {
        $('.js-sctn-instruction').css('display', 'block');
    }

    /**
     * @returns {boolean}
     */
    function isErrorMessageShown() {
        return $errorMessage.css('display') === 'block';
    }

    function showErrorMessage() {
        $errorMessage.css('display', 'block');
    }

    function hideErrorMessage() {
        $errorMessage.css('display', 'none');
    }
}